import { render, staticRenderFns } from "./sopView.vue?vue&type=template&id=94ae679e&"
import script from "./sopView.vue?vue&type=script&lang=js&"
export * from "./sopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports